export default __webpack_public_path__ + "static/media/Eggboy_v3.a7e6db29.mp3";